<!--


Props:
    
    idModal: define o id do modal.
    msg: mensagem do modal
    colorFont: cor da fonte
   

    Para chamar o modal:  
    <button v-b-modal.oii></button>

   Modal adicionar integrantes:
<ModalAlert idModal="oii" msg="deletado com sucesso!" colorFont="green" />
-->
<template>
  <div>
    <!-- The modal -->
    <b-modal
      hide-header
      hide-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
      size="sm"
      :id="idModal"
      class="modalAlert "
    >
      <div
        id="mensagem"
        v-bind:style="{
          color: colorFont,
        }"
      >
        {{ msg }}
      </div></b-modal
    >
  </div>
</template>

<script>
export default {
  props: {
    idModal: {
      type: String,
      required: true,
    },
    msg: {
      type: String,
      required: true,
    },
    colorFont: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#mensagem {
  padding-top: 1rem;
  padding-bottom: 1rem;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  font-family: "Noto Sans", sans-serif;
  padding-left: 0;
  padding-right: 0;
}
</style>
